import { Injectable } from '@angular/core';
import { BaseService } from '@base/base.service';
import { QuestionGroup } from '../models/question-group.model';

@Injectable()
export class QuestionGroupsService extends BaseService<QuestionGroup> {
  serviceUrl = '/api/question-groups';
}
